<form [formGroup]="form" [attr.aria-label]="'aria.form.meterReadings' | translate: {meterNumber: meter?.meterNumber}">
  <div class="re-bg-white re-w-full re-px-30 re-py-20 re-text re-mb-3
                md:re-w-600 md:re-mx-auto lg:re-w-900">
    <div class="re-inline">
      {{ 'general.customerData.meternumber' | translate }}
    </div>
    <div class="re-inline bold">{{meter?.meterNumber}}</div>
  </div>
  <div class="re-bg-white re-w-full re-px-30 re-py-20 re-text re-mb-3 md:re-w-600
              md:re-mx-auto lg:re-w-900">
    @if (!isExistingMeterreading) {
      @if (meter?.isSmartMeter) {
        <bdo-info-box [type]="'error'" data-qa="meterreading-not-found-in-range">
          {{ 'siminvoice.meterreadingNotFoundSmartMeter' | translate }}
        </bdo-info-box>
      } @else {
      <div>
        <div [ngClass]="{'re-text-error' : invalidText}" class="bdo-container__content">
          <div class="bdo-space--bottom"
            [innerHtml]="'siminvoice.readingNeeded' | translate">
          </div>
          <button class="bdo-space--bottom re-button re-secondary"
            type="submit"
            (click)="toMeterreadingsAdd()"
            [attr.data-qa]="'button-meterreadingAdd-' + meter?.meterNumber">
            {{ 'meterreadings.actions.enterMeterreading' | translate }}
          </button>
        </div>
      </div>
      }
    }
    @if (isExistingMeterreading) {
      @if (alternativeDate) {
        <bdo-info-box [type]="'warning'" class="re-mb-15 re-block"
          [attr.data-qa]="'info-box-alternativeDate-' + meter?.meterNumber">
          {{ 'siminvoice.readingFromDifferentDate' | translate: { date: alternativeDate | date: 'dd.MM.yyyy' } }}
        </bdo-info-box>
      }
      <div>
        <div class="re-form-item-container">
          <div class="re-mb-5">
            {{ 'meterreadings.meterreading' | translate }}
          </div>
          <bdo-input formControlName="firstZaehlwerkValue"
            [help]="alternativeDate ? '' : ('siminvoice.readingAlreadyExist' | translate)"
            [formControl]="$any(form.get('firstZaehlwerkValue'))">
          </bdo-input>
          @if (meterreading?.zaehlwerkeListe.length === 2) {
            <div class="re-mt-15">
              <div class="re-mb-5">
                {{ 'meterreadings.meterreading' | translate }}
              </div>
              <bdo-input formControlName="secondZaehlwerkValue"
                [help]="alternativeDate ? '' : ('siminvoice.readingAlreadyExist' | translate)"
                [formControl]="$any(form.get('secondZaehlwerkValue'))">
              </bdo-input>
            </div>
          }
        </div>
      </div>
      @if (alternativeDate && !meter?.isSmartMeter) {
        <div class="bdo-container__content re-mt-15">
          <button class="re-button re-secondary"
            type="submit"
            (click)="toMeterreadingsAdd()"
            [attr.data-qa]="'button-meterreadingAdd-' + meter?.meterNumber">
            {{ 'meterreadings.actions.enterMeterreading' | translate }}
          </button>
        </div>
      }
    }
  </div>
</form>
